import React from 'react'
import PropTypes from 'prop-types'
import { links } from 'common/helpers'

import Link from 'components/_new/typography/Link/Link'
import Box from 'components/_new/layout/Box/Box'

import messages from './messages'
import s from './InviteLink.scss'


const InviteLink = ({ gender, dataTestId }) => (
  <Box mt="8">
    <Link
      className={s.inviteLink}
      dataTestId={dataTestId}
      color="brand"
      to={links.invite}
      message={{
        ...messages.referFriends,
        values: { gender },
      }}
      withUnderline={false}
    />
  </Box>
)

InviteLink.propTypes = {
  gender: PropTypes.string.isRequired,
  dataTestId: PropTypes.string,
}

export default InviteLink
